import React from 'react'
import {Container, Grid, CardMedia, CardContent, Typography, CardActions, Card, Box} from '@mui/material';
import { landingStyles } from '../../styles/landing';
import { servicesStyles } from '../../styles/landing';

const card=[
   {
    img:"assets/images/services.jpg",
    heading:"General Consultation​ ",
    description:"30 minutes with an ISA Certified Arborist to answer questions and arborist report on 1 tree."
   },
   {
    img:"assets/images/services1.jpg",
    heading:"General Report ​ ",
    description:"ArborHawk standard report on up to 3 trees on the property. Price also includes 30 minute consultation with an arborist."
   },
   {
    img:"assets/images/services2.jpg",
    heading:"TRAQ Report",
    description:"Detailed report on a tree's risk of falling by ISA industry standards."
   }
]
    const services = () => {
    const classes = landingStyles()
    const clases =  servicesStyles()
     return (   
      <section id ="services">
    <Container sx={{ py: 8 }} >           
          {/* End hero unit */}
          <Grid container spacing={4}> 
          <Grid item sm={12} xs={12} md={12}> 
            <Typography >
            <Box fontFamily="CormorantBoldItalic" className={classes.heading}>Our Services</Box></Typography>
            </Grid>     
                {card.map((card)=>
                <Grid item  xs={12} sm={4} md={4} lg={4} >             
                <Card key={card}
                  className={clases.card}
                  >
                <CardMedia
                  component="img"
                  style={{height:250}}
                  image={card.img}
                  alt="random"
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {card.heading}
                  </Typography>
                  <Typography>
                    {card.description}
                  </Typography>
                </CardContent>
              </Card>
              </Grid>
                )}           
          </Grid>         
        </Container>
        </section>
  )
}

export default services

// video link :- "https://video.wixstatic.com/video/11062b_d578b9d4ffba48c68d086ec29fe9e6f0/1080p/mp4/file.mp4"